var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { hashJsonValue, proto, } from '@spotify-internal/remote-config-common';
export var FetchType;
(function (FetchType) {
    FetchType["BLOCKING"] = "blocking";
    FetchType["BACKGROUND_SYNC"] = "background_sync";
    FetchType["DELAYED"] = "delayed";
})(FetchType || (FetchType = {}));
const knownContextMap = {
    user_id: {
        policyInputName: '/spotify-user/user-id',
        encode: (value) => value,
        isIdentifier: true,
    },
    user_catalogue: {
        policyInputName: '/spotify-user/catalogue',
        encode: (value) => value,
        isIdentifier: false,
    },
    user_country: {
        policyInputName: '/spotify-user/country',
        encode: (value) => value,
        isIdentifier: false,
    },
    geoip_country: {
        policyInputName: '/client/geo-ip-country',
        encode: (value) => value,
        isIdentifier: false,
    },
    user_is_employee: {
        policyInputName: '/spotify-user/is-employee',
        encode: (value) => value,
        isIdentifier: false,
    },
    installationId: {
        policyInputName: '/remote-config/installation-id',
        encode: (value) => value,
        isIdentifier: true,
    },
    sp_t_cookie: {
        policyInputName: '/client/sp-t-cookie',
        encode: (value) => value,
        isIdentifier: true,
    },
    version: {
        policyInputName: '/remote-config/rc-client-version',
        encode: (value) => value,
        isIdentifier: false,
    },
    artist_id: {
        policyInputName: '/artist/artist-id',
        encode: (value) => value,
        isIdentifier: true,
    },
    advisor_id: {
        policyInputName: '/advisor/advisor-id',
        encode: (value) => value,
        isIdentifier: true,
    },
    adstudio_advertiser_account_id: {
        policyInputName: '/adstudio-advertiser-account/account-id',
        encode: (value) => value,
        isIdentifier: true,
    },
    oauth_client_id: {
        policyInputName: '/client/oauth-client-id',
        encode: (value) => value,
        isIdentifier: false,
    },
};
export var KnownContext;
(function (KnownContext) {
    KnownContext.definitions = knownContextMap;
    KnownContext.defaultIdentifiers = Object.freeze([
        'user_id',
        'installationId',
    ]);
    KnownContext.declarableIdentifiers = Object.freeze(Object.entries(KnownContext.definitions)
        .filter(([name, { isIdentifier }]) => isIdentifier && !KnownContext.defaultIdentifiers.includes(name))
        .map(([name]) => name));
    function extract(context) {
        return Object.entries(context)
            .filter(([key]) => key in knownContextMap)
            .reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [key]: value })), {});
    }
    KnownContext.extract = extract;
    function forEach(context, callb) {
        return Object.entries(context)
            .filter(([key]) => key in knownContextMap)
            .forEach(([key, value]) => callb(key, value, knownContextMap[key]));
    }
    KnownContext.forEach = forEach;
    function map(context, callb) {
        return Object.entries(context)
            .filter(([key]) => key in knownContextMap)
            .map(([key, value]) => callb(key, value, knownContextMap[key]));
    }
    KnownContext.map = map;
    function extractIdentifiersMap(context) {
        const identifiers = {};
        forEach(context, (_, value, def) => {
            if (def.isIdentifier) {
                const encodedValue = def.encode(value);
                if (typeof encodedValue === 'string' && encodedValue !== '') {
                    identifiers[def.policyInputName] = encodedValue;
                }
            }
        });
        if (knownContextMap.installationId.policyInputName in identifiers &&
            !(knownContextMap.sp_t_cookie.policyInputName in identifiers)) {
            identifiers[knownContextMap.sp_t_cookie.policyInputName] =
                identifiers[knownContextMap.installationId.policyInputName];
        }
        return identifiers;
    }
    KnownContext.extractIdentifiersMap = extractIdentifiersMap;
    function extractDeclaredIdentifiers(context) {
        return Object.keys(context).filter(key => KnownContext.declarableIdentifiers.includes(key));
    }
    KnownContext.extractDeclaredIdentifiers = extractDeclaredIdentifiers;
    function hash(context) {
        if (context.username) {
            return hashJsonValue(Object.assign(Object.assign({}, extract(context)), { username: context.username }));
        }
        return hashJsonValue(extract(context));
    }
    KnownContext.hash = hash;
})(KnownContext || (KnownContext = {}));
export var ResolveRequest;
(function (ResolveRequest) {
    function toPayload(_a) {
        var { propertySetId, fetchType = FetchType.BLOCKING } = _a, context = __rest(_a, ["propertySetId", "fetchType"]);
        return {
            propertySetId,
            context: payloadContext(context),
            fetchType: payloadFetchType(fetchType),
        };
    }
    ResolveRequest.toPayload = toPayload;
    function encode(req) {
        return proto.ResolveRequest.encode(toPayload(req)).finish();
    }
    ResolveRequest.encode = encode;
    function payloadContext(ctx) {
        const context = [];
        KnownContext.forEach(ctx, (_, value, { policyInputName, encode }) => {
            const encoded = encode(value);
            if (typeof encoded === 'string' && encoded !== '') {
                context.push({
                    knownContext: undefined,
                    policyInputName,
                    value: encoded,
                });
            }
        });
        return {
            context,
        };
    }
    function payloadFetchType(ft) {
        switch (ft) {
            case FetchType.BACKGROUND_SYNC:
                return { type: proto.Fetch_Type.BACKGROUND_SYNC };
            case FetchType.BLOCKING:
                return { type: proto.Fetch_Type.BLOCKING };
            case FetchType.DELAYED:
                return { type: proto.Fetch_Type.ASYNC };
            default:
                throw new Error(`Unknown FetchType (${ft})`);
        }
    }
})(ResolveRequest || (ResolveRequest = {}));
//# sourceMappingURL=request.js.map